module.exports = __webpack_public_path__ + "img/icon-checkbox-disabled.e73b0c58.svg";